import HistoryView from "./HistoryView";
export default HistoryView;